import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static targets = [];

   navigate(event) {
      const buttonElement = event.target;
      const name = buttonElement.name;
      const val = buttonElement.value;
      const url = new URL(document.location);
      url.searchParams.set(name, val);
      Turbo.visit(url, { frame: "accessibility", action: "advance" });
   }
}
